import React from 'react';
import './values.scss';

import UNI_ICON from "assets/icons/uni_icon.png";
import {ReactComponent as ELEMENT_01} from "assets/business-education-assets/elements/be_element_01.svg";

const data: { image: any, heading: string, paragraph: string }[] = [
    {
        image: UNI_ICON,
        heading: "We Care About You",
        paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis."
    },
    {
        image: UNI_ICON,
        heading: "We Treat You Like Family",
        paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis."
    },
    {
        image: UNI_ICON,
        heading: "We Are Experts",
        paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis."
    },
    {
        image: UNI_ICON,
        heading: "We Are Reliable",
        paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis."
    },
    {
        image: UNI_ICON,
        heading: "Establishing ownership of the business",
        paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis."
    },
    {
        image: UNI_ICON,
        heading: "Establishing ownership of the business",
        paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis."
    }
]

const Values: React.FC = () => {
    return (
        <div className={'about-values'} id={'values'}>
            <ELEMENT_01 className={'about-values_element_01'}/>

            <div className={'about-values_wrapper max'}>
                <div className={'about-values_wrapper_top'}>
                    <h1>Our Values</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Faucibus turpis felis sit ipsum
                        lacinia est, interdum accumsan. Consequat sem gravida nisl risus, enim facilisis ultrices.
                        Scelerisque a feugiat commodo tristique augue. Tellus nam vitae in et eget sagittis elementum.
                        Tellus tristique pharetra, aenean egestas velit augue tristique mauris. Vitae in lacinia morbi
                        eros, gravida tempus, at natoque. </p>
                </div>
                <div className={'about-values_wrapper_bottom'}>
                    <div className={'about-values_wrapper_bottom_benefits'}>
                        {
                            data.map(({image, paragraph, heading}, index) => (
                                <div key={heading + index} className="about-values_wrapper_bottom_benefits_benefit">
                                    <img src={image} alt=""/>
                                    <h2>{heading}</h2>
                                    <p>{paragraph}</p>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Values;
